var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{staticClass:"ma-0 pa-0",attrs:{"cols":"12","md":"12"}},[(_vm.image !== '')?_c('MainImageComponent',{attrs:{"image":_vm.image}}):_c('MainVideoComponent',{attrs:{"video":_vm.video}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }